// extracted by mini-css-extract-plugin
export default {"info":"Info_info__uKDwz","item":"Info_item__PR96D","icon":"Info_icon__qrw0D"};